import { useTheme } from "@emotion/react";
import { Box, Card, Grid, Modal, useMediaQuery } from "@mui/material";

import Post from "page-sections/dashboards/forum-detail/Post";
import { X } from "react-feather";

export default function CommunityModal({ showModal, setShowModal }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: isMobile ? "95%" : "60%",
    maxHeight: "90vh",
    overflowY: "auto",
    backgroundColor: "white",
    border: "none",
    boxShadow: 24,
    scrollbarWidth: "thin",
    "&::-webkit-scrollbar": {
      width: "0.4em",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "transparent",
    },
  };

  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <>
      <Modal
        open={showModal}
        onClose={handleClose}
        disableEnforceFocus={true}
        disableBackdropClick={false} // Disable closing when clicking on the backdrop
        disableEscapeKeyDown={true}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{
          backdropFilter: "blur(5px)",
          backgroundColor: "transparent",
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.5)",
        }}
      >
        <Card sx={style}>
          <Grid py={0} sx={{ borderRadius: "10px" }}>
            <Box
              sx={{
                flexDirection: "row",
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                padding: "0px 16px 0px 0px",
                background: "white",
              }}
            >
              <Box
                onClick={() => handleClose()}
                sx={{
                  position: "absolute",
                  right: "16px",
                  top: "16px",
                  width: "32px",
                  height: "32px",
                  backgroundColor: theme.palette.borderColor,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: 100,
                  cursor: "pointer",
                }}
              >
                <X color={theme.palette.grey400} />
              </Box>
            </Box>
            <Post isModal={true} />
          </Grid>
        </Card>
      </Modal>
    </>
  );
}
